import { resolveByCountry } from '@codex/helpers';
import { getPageUrlPrefixForSegmentListingPage } from './helpers/converterHelper';

export function convertUCMSHierarchyToReduxFormat(ucmsResponseJSON) {
  const universes = [];
  const categories = [];
  const markets = [];
  const segments = [];

  ucmsResponseJSON.forEach(
    (currentUniverse) => {
      universes.push({
        id: currentUniverse.id,
        name: currentUniverse.name,
        src: currentUniverse.src
      });

      currentUniverse.categories.forEach(
        (currentCategory) => {
          categories.push({
            id: currentCategory.id,
            name: currentCategory.name,
            src: currentCategory.src,
            universeId: currentUniverse.id
          });

          currentCategory.markets.forEach(
            (currentMarket) => {
              markets.push({
                id: currentMarket.id,
                name: currentMarket.name,
                src: currentMarket.src,
                categoryId: currentCategory.id
              });

              currentMarket.segments.forEach(
                (currentSegment) => {
                  segments.push({
                    id: currentSegment.id,
                    name: currentSegment.name,
                    src: currentSegment.src,
                    marketId: currentMarket.id
                  });
                }
              );
            });
        }
      );
    }
  );

  return {
    universes,
    categories,
    markets,
    segments
  };
}

// This function can be used only on client because it requires window object
export function generateListingPageUrlFromUCMSHierarchy(segmentId, ucmsHierarchy) {
  const { name: segmentName, marketId } =
    ucmsHierarchy.segments.find((segmentData) => segmentData.id === segmentId);
  const { name: marketName, categoryId } =
    ucmsHierarchy.markets.find((marketData) => marketData.id === marketId);

  const { name: categoryName, universeId } =
    ucmsHierarchy.categories.find((categoryData) => categoryData.id === categoryId);

  const { name: universeName } =
    ucmsHierarchy.universes.find((universeData) => universeData.id === universeId);

  const { protocol, hostname, port } = window.location;

  const listingPageUrlPrefix = getPageUrlPrefixForSegmentListingPage(
    `${protocol}//${hostname}${port ? `:${port}` : ''}${resolveByCountry('/gbuk', '/ieen')}`,
    null,
    null,
    { universeName, categoryName, marketName, segmentName }
  );

  return `${listingPageUrlPrefix}/${categoryId}_${marketId}_${segmentId}_xx_xx/xx-criteria.html`;
}


